import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConferenceRoutingModule } from './conference-routing.module';
import { AuthService } from 'src/app/core/services/auth.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClientJsonpModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RoomComponent } from './room/room.component';
import { HttpInterceptorProviders } from 'src/app/core/interceptors';
import { RouteStateService } from 'src/app/core/services/route-state.service';
import { BootstrapModule } from 'src/app/shared/shared-bootstrap.module';



@NgModule({
  declarations: [
    RoomComponent
  ],
  imports: [
    CommonModule,
    ConferenceRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    HttpClientJsonpModule,
    ReactiveFormsModule,
    BootstrapModule
  ],
  providers: [
    RouteStateService,
    AuthService,
    HttpInterceptorProviders,
  ],
})
export class ConferenceModule { }
